import { format } from "date-fns";

export const formatDate = (date: string | null | undefined): string => {
  return date ? format(new Date(date), "MM-dd-yyyy") : "";
};


export const formatDate2 = (date: string | null | undefined): string => {
  return date ? format(new Date(date), "yyyy-MM-dd") : "";
};